var _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon icon-tabler icon-tabler-square-check",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "#6251ad",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12l2 2l4 -4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCheckbox);
export default __webpack_public_path__ + "static/media/checked-checkbox.5703bc1867e06c09d52f6edddd865cb9.svg";
export { ForwardRef as ReactComponent };